import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'method',
  standalone: false
})
export class MethodPipe implements PipeTransform {
  transform<T extends object, K extends keyof T, R extends T[K] extends (...args: any[]) => infer Ret ? Ret : never>(
    classObject: T,
    methodKey: K,
    ...args: T[K] extends (...args: infer P) => any ? P : never
  ): R | undefined {
    const method = classObject?.[methodKey];
    if (typeof method === 'function') {
      return method?.bind(classObject)?.(...(args as any)) as R;
    }
    return undefined;
  }
}
